// router.tsx

import { createBrowserRouter } from "react-router";

import RootLayout from "./RootLayout";
import ProtectedLayout from "./ProtectedLayout";
import PublicLayout from "./PublicLayout";
import ErrorPage from "./ErrorPage";
import RestaurantIdGuard from "./RestaurantIdGuard";

import HomePage from "../pages/HomePage";
import MenuPage from "../pages/MenuPage";
import CheckoutPage from "../pages/CheckoutPage";
import ViewCartPage from "../pages/ViewCartPage";
import TableReservationsPage from "../pages/TableReservationsPage";
import DynamicRoutePage from "../pages/DynamicRoutePage";
import LocationSelector from "../components/LocationSelector";

const restaurantChildren = [
  {
    index: true,
    Component: HomePage,
  },
  {
    path: "menu",
    Component: MenuPage,
  },

  // Stripe
  {
    path: "menu/stripe/payment-success/:restaurantId/:orderId",
    Component: MenuPage,
  },
  {
    path: "menu/stripe/payment-failed/:restaurantId/:orderId",
    Component: MenuPage,
  },

  // Quantic
  {
    path: "menu/quantic/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/quantic/payment-failed",
    Component: MenuPage,
  },

  // CardPointe
  {
    path: "menu/cardpointe/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/cardpointe/payment-failed",
    Component: MenuPage,
  },

  // NMI
  {
    path: "menu/nmi/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/nmi/payment-failed",
    Component: MenuPage,
  },

  // AcceptBlue
  {
    path: "menu/acceptblue/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/acceptblue/payment-failed",
    Component: MenuPage,
  },

  // Authorize.Net
  {
    path: "menu/authorizedotnet/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/authorizedotnet/payment-failed",
    Component: MenuPage,
  },

  // Clover
  {
    path: "menu/clover/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/clover/payment-failed",
    Component: MenuPage,
  },

  // Square
  {
    path: "menu/square/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/square/payment-failed",
    Component: MenuPage,
  },

  // Dejavoo
  {
    path: "menu/dejavoo/payment-success",
    Component: MenuPage,
  },
  {
    path: "menu/dejavoo/payment-failed",
    Component: MenuPage,
  },

  // Other pages
  {
    path: "Table-Reservations",
    Component: TableReservationsPage,
  },
  {
    path: "checkout",
    Component: CheckoutPage,
  },
  {
    path: "cart",
    Component: ViewCartPage,
  },

  // Dynamic route must remain last.
  {
    path: ":slug",
    Component: DynamicRoutePage,
  },
];

export const router = createBrowserRouter([
  {
    Component: RootLayout,
    errorElement: <ErrorPage />,
    children: [
      // Preview edit
      {
        path: "/:id/preview/edit",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },

      // Preview
      {
        path: "/:id/preview",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },

      // Parent restaurant
      {
        path: "/parent-restaurants/:parentId",
        Component: PublicLayout,
        children: [
          {
            index: true,
            Component: LocationSelector,
          },
        ],
      },

      // Restaurant
      {
        path: "/:id",
        Component: RestaurantIdGuard,
        children: [
          {
            Component: ProtectedLayout,
            children: restaurantChildren,
          },
        ],
      },

      // Select location
      {
        Component: PublicLayout,
        children: [
          {
            path: "select-location",
            Component: LocationSelector,
          },
        ],
      },

      // Domain home
      {
        path: "/",
        Component: ProtectedLayout,
        children: restaurantChildren,
      },
    ],
  },
]);
